import { render, staticRenderFns } from "./StaticIframe.vue?vue&type=template&id=89b15284&scoped=true"
import script from "./StaticIframe.vue?vue&type=script&lang=js"
export * from "./StaticIframe.vue?vue&type=script&lang=js"
import style0 from "./StaticIframe.vue?vue&type=style&index=0&id=89b15284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b15284",
  null
  
)

export default component.exports